/**
 * نصوص «لوحة الطلبات» (/advertisements): طلبات عقارية مخصّصة ينشرها أصحاب
 * الحسابات المهنية ويردّون عليها. اللوحة للحسابات المهنية فقط، قراءةً ونشراً.
 * تُستخدم عبر useTranslation(['ads', 'gating']).
 */
const ads = {
  title: 'لوحة الطلبات',
  subtitle:
    'انشر طلباً عقارياً مخصّصاً، مثل بناء مدرسة في حي معيّن، ليرد عليه الوسطاء والشركات والمطوّرون والمختصون العقاريون.',
  post: 'أضف طلباً',
  cancel: 'إلغاء',

  form: {
    heading: 'طلب جديد',
    title: 'عنوان الطلب',
    titlePlaceholder: 'مثال: أرض لبناء مدرسة',
    titleHint: 'عنوان قصير يصف طلبك، من 3 أحرف على الأقل.',
    titleTooShort: 'اكتب عنواناً من 3 أحرف على الأقل.',
    body: 'تفاصيل الطلب',
    bodyPlaceholder: 'الموقع والمساحة والميزانية والمدة وأي شروط أخرى.',
    bodyHint: 'كلما اتضحت التفاصيل جاءت الردود أدق.',
    bodyTooShort: 'اكتب تفاصيل من 5 أحرف على الأقل.',
    category: 'التصنيف (اختياري)',
    categoryPlaceholder: 'مثال: أراضٍ، تطوير، استثمار',
    submit: 'انشر الطلب',
    published: 'تم نشر طلبك في اللوحة.',
  },

  list: {
    heading: 'الطلبات المفتوحة',
    loading: 'جارٍ تحميل الطلبات…',
    empty: 'لا توجد طلبات مفتوحة حالياً.',
    emptyHint: 'انشر أول طلب، وسيظهر هنا لأصحاب الحسابات المهنية.',
    replies: 'الردود: {{n}}',
    yours: 'طلبك',
  },

  detail: {
    loading: 'جارٍ تحميل الردود…',
    loadError: 'تعذّر تحميل الردود.',
    repliesHeading: 'الردود',
    noReplies: 'لا توجد ردود بعد.',
    yourReply: 'ردّك',
    replyLabel: 'اكتب ردّاً',
    replyPlaceholder: 'اكتب ردّك على هذا الطلب…',
    send: 'إرسال',
    replySent: 'تم إرسال ردّك.',
    closePost: 'أغلق الطلب',
    closeConfirm: 'هل تريد إغلاق هذا الطلب؟ لن يظهر في اللوحة ولن يستقبل ردوداً بعد إغلاقه.',
    closeYes: 'نعم، أغلق الطلب',
    closeNo: 'تراجع',
    closed: 'تم إغلاق الطلب.',
  },

  errors: {
    disabled: 'لوحة الطلبات غير مفعّلة حالياً.',
    load: 'تعذّر تحميل لوحة الطلبات. تحقّق من اتصالك ثم أعد المحاولة.',
    post: 'تعذّر نشر طلبك. حاول مرة أخرى.',
    invalid: 'تحقّق من العنوان والتفاصيل ثم أعد المحاولة.',
    reply: 'تعذّر إرسال ردّك. حاول مرة أخرى.',
    replyClosed: 'هذا الطلب مغلق ولم يعد يستقبل ردوداً.',
    notFound: 'لم يعد هذا الطلب متاحاً.',
    close: 'تعذّر إغلاق الطلب. حاول مرة أخرى.',
    notOwner: 'يغلق الطلب صاحبه فقط.',
    retry: 'إعادة المحاولة',
  },

  session: {
    title: 'انتهت جلستك',
    body: 'سجّل الدخول مرة أخرى لمتابعة لوحة الطلبات.',
    signIn: 'سجّل الدخول',
  },
};

export default ads;
